import { BaseStore } from '../BaseStore';

const PipelineRunStore = BaseStore.named('PipelineRunStore')
  .props({
    id: '',
    tickPeriod: 300 * 1000, // 5 minutes
  })

  .actions(self => {
    // save the base implementation of cleanup
    const superCleanup = self.cleanup;

    return {
      async doLoad() {/**/},
      cleanup: () => {
        superCleanup();
      },
    };
  })

  .views(_self => ({/**/}));

// Note: Do NOT register this in the global context, if you want to gain access to an instance
//       use environmentsStore.getEnvironmentStore()
// eslint-disable-next-line import/prefer-default-export
export { PipelineRunStore };
